const acessoSalvo = localStorage.getItem("acessoAtivo");
const perfilSalvo = localStorage.getItem("perfilAtivo");

const initialState = {
  toggle_header: false,
  layoutstyledata: localStorage.getItem("layoutStyling"),

  auth: {
    user: null,
  },

  access: {
    acessos: [],
    acessoAtivo: acessoSalvo ? JSON.parse(acessoSalvo) : null,
    perfilAtivo: perfilSalvo ? JSON.parse(perfilSalvo) : null,
  },
};

export default initialState;
